import { useState, useEffect } from "react";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import swal from "sweetalert";
import CustomPhoneInput from "../Agents/InputField";
import { isValidPhoneNumber } from "react-phone-number-input";
import * as FaIcons from "react-icons/fa";

function LeadsModel({ show, onClose, type, lead, fetchLeads }) {

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(() => {
    const base = lead || {};
    const documentsArray = base?.documents_link
      ? base?.documents_link?.split(",").filter((link) => link.trim() !== "")
      : [];

    return {
      ...base,
      documents: documentsArray,
    };
  });
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const isEdit = type === "edit";
  const [errors, setErrors] = useState({});

  const educationLevels = [
    { value: "Middle", label: "Middle" },
    { value: "Matric", label: "Matric (10th Grade)" },
    { value: "O-Level", label: "O-Level" },
    { value: "A-Level", label: "A-Level" },
    { value: "Intermediate", label: "Intermediate (FA/FSc/ICS)" },
    { value: "Diploma", label: "Diploma / Certificate" },
    { value: "Bachelor", label: "Bachelor's Degree" },
    { value: "Master", label: "Master's Degree" },
    { value: "PhD", label: "PhD" },
    { value: "Other", label: "Other" },
  ];

  const visaType = [
    { value: "Student", label: "Student" },
    { value: "Sponsor", label: "Sponsor" },
    { value: "PR", label: "PR" },
    { value: "Work", label: "Work" },
  ];
  const modeOfClass = [
    { value: "online", label: "Online" },
    { value: "physical", label: "Physical" },
    { value: "hybrid", label: "Hybrid" },
  ];

  const englishTests = [
    { value: "Duolingo", label: "Duolingo" },
    { value: "IELTS", label: "IELTS" },
    { value: "PTE", label: "PTE" },
    { value: "TOEFL", label: "TOEFL" },
    { value: "Oxford", label: "Oxford" },
    { value: "MOI", label: "MOI" },
    { value: "Cambridge", label: "Cambridge" },
    { value: "None", label: "None" },
  ];

  // Validation helpers
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isNumeric = (value) => !isNaN(value) && value.trim() !== "";
  const hasNumbers = (value) => /\d/.test(value);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDocumentChange = (index, value) => {
    const updatedDocs = [...formData.documents];
    updatedDocs[index] = value;
    setFormData((prev) => ({
      ...prev,
      documents: updatedDocs,
    }));
  };

  const addDocumentRow = () => {
    setFormData((prev) => ({
      ...prev,
      documents: [...prev.documents, ""],
    }));
  };

  const removeDocumentRow = (index) => {
    setFormData((prev) => ({
      ...prev,
      documents: prev.documents.filter((_, i) => i !== index),
    }));
  };
  const handleEditSubmit = async () => {
    const validationErrors = {};

    if (hasNumbers(formData.client_name)) {
      validationErrors.client_name = "Client name should not contain numbers.";
    }
    if (formData.email && !isValidEmail(formData.email)) {
      validationErrors.email = "Please enter a valid email address.";
    }
    if (!isValidPhoneNumber(formData.phone)) {
      validationErrors.phone = "Invalid Phone Number";
    }
    if (hasNumbers(formData.city)) {
      validationErrors.city = "City should not contain numbers.";
    }
    if (hasNumbers(formData.destination_country)) {
      validationErrors.destination_country =
        "DestinationCountry should not contain numbers.";
    }

    const documentsString = formData.documents
      .filter((doc) => doc.trim() !== "")
      .join(",");

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...formData,
        documents_link: documentsString,
      };
      const response = await apiUrl.put(
        `editCompaignLeads/${lead.id}`,
        payload
      );
      if (response.status === 200) {
        swal("Success", "Lead updated successfully!", "success");
        onClose();
        fetchLeads();
        setErrors({});
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while updating.";
      swal("Update Failed", message, "error");
    } finally {
      setLoading(false);
    }
  };
  console.log("formData", formData);
  const getStatusCode = async () => {
    try {
      const response = await apiUrl.get("getStatusCodes");
      if (response?.data?.data) {
        setSelectedOptions(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching status codes:", error);
    }
  };

  const getAllUsers = async () => {
    try {
      const response = await apiUrl.get("fetchAllActiveUsers");
      if (response?.data?.data) {
        setAllUsers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    if (lead) {
      const documentsArray = lead.documents_link
        ? lead.documents_link.split(",").filter((link) => link.trim() !== "")
        : [];

      setFormData({
        ...lead,
        documents: documentsArray,
      });

      getStatusCode();
      getAllUsers();
    }
  }, [lead]);

  const getStatusLabel = (statusId) => {
    const status = selectedOptions.find((opt) => opt.id == statusId);
    return status ? status.label : "N/A";
  };

  const getUserName = (userId) => {
    const user = allUsers.find((u) => u.id == userId);
    return user ? user.name : "N/A";
  };
  console.log("formData", formData);
  if (!show || !lead) return null;
  const countryCodePattern = /^\+\d+/;

  return (
    <>
      {/* Backdrop */}
      <div
        className="modal-backdrop fade show"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.45)",
          zIndex: 1040,
        }}
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050 }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          style={{ minWidth: 800 }}
        >
          <div
            className="modal-content border-0 rounded-4 shadow"
            style={{ overflow: "hidden" }}
          >
            {/* Header */}
            <div
              className="modal-header"
              style={{
                background: "#f7f8fa",
                borderBottom: "1px solid #eef2f6",
              }}
            >
              <div>
                <h5 className="modal-title" style={{ fontWeight: 700 }}>
                  {isEdit ? "Edit Lead" : "View Lead"}
                </h5>
                <div className="text-muted" style={{ fontSize: 12 }}>
                  Update or view lead details below.
                </div>
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setErrors({});
                  onClose();
                }}
              />
            </div>

            {/* Body */}
            <div className="modal-body">
              <div className="card p-6 bg-gradient-to-br from-blue-50 to-blue-100 mb-4">
                <div className="text-center space-y-2">
                  <p className="text-sm text-gray-600">Total Score</p>
                  <div className="text-5xl font-bold">
                    {formData?.score?.total_score}/100
                  </div>

                  <div className="w-full bg-gray-200 rounded-full h-2 mt-3">
                    <div
                      className="bg-blue-600 h-2 rounded-full"
                      style={{
                        width: `${(formData?.score?.total_score / 100) * 100}%`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  padding: "15px",
                }}
              >
                {/* Contact Information */}
                <div
                  style={{
                    background: "#fafafa",
                    padding: "20px",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div className="mb-3">
                    <p
                      className="mb-1"
                      style={{ fontWeight: 500, color: "#475569" }}
                    >
                      Age Points: {formData?.score?.age_points ?? 0} / 10
                    </p>

                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-blue-600 h-2 rounded-full"
                        style={{
                          width: `${
                            ((formData?.score?.age_points ?? 0) / 10) * 100
                          }%`,
                        }}
                      ></div>
                    </div>
                  </div>
                  <h6
                    className="mb-3"
                    style={{
                      fontWeight: 600,
                      color: "#1e293b",
                      fontSize: "1rem",
                    }}
                  >
                    Contact Information
                  </h6>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="ms-1">Client Name</label>
                      {isEdit ? (
                        <input
                          type="text"
                          className={`form-control ${
                            errors.client_name ? "is-invalid" : ""
                          }`}
                          name="client_name"
                          value={formData.client_name || ""}
                          onChange={handleInputChange}
                          placeholder="Enter client name"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.client_name || "N/A"}
                        </div>
                      )}
                      {errors.client_name && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "0.875em", marginTop: "0.25rem" }}
                        >
                          {errors.client_name}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Client DOB</label>
                      {isEdit ? (
                        <input
                          type="date"
                          className={`form-control ${
                            errors.date_of_birth ? "is-invalid" : ""
                          }`}
                          name="date_of_birth"
                          value={formData.date_of_birth || ""}
                          onChange={handleInputChange}
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.date_of_birth || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Age</label>
                      {isEdit ? (
                        <input
                          type="number"
                          className={`form-control ${
                            errors.age ? "is-invalid" : ""
                          }`}
                          name="age"
                          min={1}
                          max={100}
                          value={formData.age || ""}
                          onChange={handleInputChange}
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.age || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Email Address</label>
                      {isEdit ? (
                        <input
                          type="email"
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          name="email"
                          value={formData.email || ""}
                          onChange={handleInputChange}
                          placeholder="Enter email address"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.email || "N/A"}
                        </div>
                      )}
                      {errors.email && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "0.875em", marginTop: "0.25rem" }}
                        >
                          {errors.email}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* <div className="row g-3 mt-3">
                    <div className="col-md-8">
                      {isEdit ? (
                        <CustomPhoneInput
                          value={formData.phone || ""}
                          onChange={(value) => {
                            setFormData((prev) => ({
                              ...prev,
                              phone: value,
                            }));
                          }}
                          placeholder="Enter phone number"
                          defaultCountry="PK"
                          className={
                            errors.phone
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.phone || "N/A"}
                        </div>
                      )}
                      <h5 className="acc-label pl-2">
                        {countryCodePattern.test(formData?.phone)
                          ? formData?.phone
                          : formData.clients["country"] == "Pakistan"
                          ? "+92" + formData?.phone
                          : "+61" + formData?.phone}
                        <a
                          href={`https://wa.me/${
                            countryCodePattern.test(formData?.phone)
                              ? formData?.phone
                              : formData.clients["country"] == "Pakistan"
                              ? "+92" + formData?.phone
                              : "+61" + formData?.phone
                          }`}
                          className="whatsapp_float"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaIcons.FaWhatsapp size="15" color="rgb(0 140 0)" />
                        </a>
                      </h5>
                      {errors.phone && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "0.875em", marginTop: "0.25rem" }}
                        >
                          {errors.phone}
                        </div>
                      )}
                    </div>
                  </div> */}
                  <div className="row g-3 mt-3">
                    <div className="col-md-8 d-flex align-items-center">
                      {/* WhatsApp Button — always first (left side) */}
                      {formData.phone && (
                        <a
                          href={`https://wa.me/${formData.phone.replace(
                            /\D/g,
                            ""
                          )}`}
                          className="btn btn-sm btn-success d-flex align-items-center justify-content-center me-2"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Chat on WhatsApp"
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            padding: 0,
                            flexShrink: 0,
                          }}
                        >
                          <FaIcons.FaWhatsapp size="14" color="white" />
                        </a>
                      )}

                      {/* Phone Input or Plain Text */}
                      {isEdit ? (
                        <CustomPhoneInput
                          value={formData.phone || ""}
                          onChange={(value) => {
                            setFormData((prev) => ({ ...prev, phone: value }));
                          }}
                          placeholder="Enter phone number"
                          defaultCountry="PK"
                          className={
                            errors.phone
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.phone || "N/A"}
                        </div>
                      )}
                    </div>

                    {errors.phone && (
                      <div className="col-md-8">
                        <div
                          className="text-danger"
                          style={{ fontSize: "0.875em", marginTop: "0.25rem" }}
                        >
                          {errors.phone}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Location & Destination */}
                <div
                  style={{
                    background: "#fafafa",
                    padding: "20px",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <h6
                    className="mb-3"
                    style={{
                      fontWeight: 600,
                      color: "#1e293b",
                      fontSize: "1rem",
                    }}
                  >
                    Location & Destination
                  </h6>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="ms-1">Current City</label>
                      {isEdit ? (
                        <input
                          type="text"
                          className={`form-control ${
                            errors.city ? "is-invalid" : ""
                          }`}
                          name="city"
                          value={formData.city || ""}
                          onChange={handleInputChange}
                          placeholder="Islamabad"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.city || "N/A"}
                        </div>
                      )}
                      {errors.city && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "0.875em", marginTop: "0.25rem" }}
                        >
                          {errors.city}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Destination Country</label>
                      {isEdit ? (
                        <input
                          type="text"
                          className="form-control"
                          name="destination_country"
                          value={formData.destination_country || ""}
                          onChange={handleInputChange}
                          placeholder="Canada"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.destination || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Destination State</label>
                      {isEdit ? (
                        <input
                          type="text"
                          className="form-control"
                          name="state"
                          value={formData.state || ""}
                          onChange={handleInputChange}
                          placeholder="Ontario"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.state || "N/A"}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Education & Course */}
                <div
                  style={{
                    background: "#fafafa",
                    padding: "20px",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div className="mb-3">
                    <p
                      className="mb-1"
                      style={{ fontWeight: 500, color: "#475569" }}
                    >
                      Education Level Score:{" "}
                      {formData?.score?.education_points ?? 0} / 10
                    </p>

                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-blue-600 h-2 rounded-full"
                        style={{
                          width: `${
                            ((formData?.score?.education_points ?? 0) / 10) *
                            100
                          }%`,
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <p
                      className="mb-1"
                      style={{ fontWeight: 500, color: "#475569" }}
                    >
                      Academic Score: {formData?.score?.academic_points ?? 0} /
                      20
                    </p>

                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-blue-600 h-2 rounded-full"
                        style={{
                          width: `${
                            ((formData?.score?.academic_points ?? 0) / 20) * 100
                          }%`,
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <p
                      className="mb-1"
                      style={{ fontWeight: 500, color: "#475569" }}
                    >
                      Study Gap: {formData?.score?.study_gap_points ?? 0} / 15
                    </p>

                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-blue-600 h-2 rounded-full"
                        style={{
                          width: `${
                            ((formData?.score?.study_gap_points ?? 0) / 15) *
                            100
                          }%`,
                        }}
                      ></div>
                    </div>
                  </div>
                  <h6
                    className="mb-3"
                    style={{
                      fontWeight: 600,
                      color: "#1e293b",
                      fontSize: "1rem",
                    }}
                  >
                    Education & Course
                  </h6>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="ms-1">Previous Education</label>
                      {isEdit ? (
                        <select
                          className="form-select"
                          name="education"
                          value={formData.education || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Education level</option>
                          {educationLevels.map((level) => (
                            <option key={level.value} value={level.value}>
                              {level.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.education || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">University / College</label>
                      {isEdit ? (
                        <input
                          type="text"
                          className="form-control"
                          name="bachelor_institution"
                          value={formData.bachelor_institution || ""}
                          onChange={handleInputChange}
                          placeholder="National University of Sciences and Technology"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.bachelor_institution || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Majore Subject</label>
                      {isEdit ? (
                        <input
                          type="text"
                          className="form-control"
                          name="bachelor_subject"
                          value={formData.bachelor_subject || ""}
                          onChange={handleInputChange}
                          placeholder="BS Computer Science"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.bachelor_subject || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Interested Course</label>
                      {isEdit ? (
                        <input
                          type="text"
                          className="form-control"
                          name="course"
                          value={formData.course || ""}
                          onChange={handleInputChange}
                          placeholder="MS Computer Science"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.course || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Passing Year</label>
                      {isEdit ? (
                        <input
                          type="number"
                          className="form-control"
                          name="passing_year"
                          value={formData.passing_year || ""}
                          onChange={handleInputChange}
                          min="1900"
                          max={new Date().getFullYear()}
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.passing_year || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">CGPA</label>
                      {isEdit ? (
                        <input
                          type="number"
                          className="form-control"
                          name="academic_cgpa"
                          value={formData.academic_cgpa || ""}
                          onChange={handleInputChange}
                          step="0.01"
                          min="0"
                          max="100"
                          placeholder="3.4"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.academic_cgpa || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Percentage</label>
                      {isEdit ? (
                        <input
                          type="number"
                          className="form-control"
                          name="academic_percentage"
                          value={formData.academic_percentage || ""}
                          onChange={handleInputChange}
                          min="0"
                          max="100"
                          placeholder="80"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.academic_percentage || "N/A"}
                        </div>
                      )}
                    </div>
                    {/* Add these inside Education & Course section, after CGPA field */}
                    <div className="col-md-6">
                      <label className="ms-1">Study Gap (Years)</label>
                      {isEdit ? (
                        <input
                          type="number"
                          className="form-control"
                          name="study_gap"
                          value={formData.study_gap || ""}
                          onChange={handleInputChange}
                          min="0"
                          max="20"
                          placeholder="e.g. 2"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.study_gap !== undefined &&
                          formData.study_gap !== null
                            ? `${formData.study_gap} year(s)`
                            : "N/A"}
                        </div>
                      )}
                    </div>

                    <div className="col-md-6">
                      <label className="ms-1">Visa Refusal Count</label>
                      {isEdit ? (
                        <input
                          type="number"
                          className="form-control"
                          name="refusal_count"
                          value={formData.refusal_count || ""}
                          onChange={handleInputChange}
                          min="0"
                          max="10"
                          placeholder="e.g. 1"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.refusal_count || "N/A"}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Visa & Budget */}
                <div
                  style={{
                    background: "#fafafa",
                    padding: "20px",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div className="mb-3">
                    <p
                      className="mb-1"
                      style={{ fontWeight: 500, color: "#475569" }}
                    >
                      English Test Score :{" "}
                      {formData?.score?.english_test_points ?? 0} / 15
                    </p>

                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-blue-600 h-2 rounded-full"
                        style={{
                          width: `${
                            ((formData?.score?.english_test_points ?? 0) / 15) *
                            100
                          }%`,
                        }}
                      ></div>
                    </div>
                  </div>
                  <h6
                    className="mb-3"
                    style={{
                      fontWeight: 600,
                      color: "#1e293b",
                      fontSize: "1rem",
                    }}
                  >
                    Visa / Classes & Budget
                  </h6>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="ms-1">Visa Type</label>
                      {isEdit ? (
                        <select
                          className="form-select"
                          name="visa"
                          value={formData.visa || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Visa</option>
                          {visaType.map((type) => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.visa || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">English Test</label>
                      {isEdit ? (
                        <select
                          className="form-select"
                          name="eng_test"
                          value={formData.eng_test || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Test</option>
                          {englishTests.map((test) => (
                            <option key={test.label} value={test.value}>
                              {test.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.eng_test || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">English Test Score</label>

                      {isEdit ? (
                        <input
                          type="number"
                          className="form-control"
                          name="eng_test_score"
                          value={formData.eng_test_score}
                          onChange={handleInputChange}
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.eng_test_score || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1"> Time Slot</label>

                      {isEdit ? (
                        <input
                          type="text"
                          className="form-control"
                          name="time_slot"
                          value={formData.time_slot}
                          onChange={handleInputChange}
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.time_slot || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1"> Mode of Class</label>

                      {isEdit ? (
                        <select
                          className="form-select"
                          name="mode_of_class"
                          value={formData.mode_of_class || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Mode of Class</option>
                          {modeOfClass.map((type) => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.mode_of_class || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Budget Min</label>
                      {isEdit ? (
                        <input
                          type="number"
                          className="form-control"
                          name="budget_min"
                          value={formData.budget_min || ""}
                          onChange={handleInputChange}
                          placeholder="3000000"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.budget_min || "N/A"}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Budget Max</label>
                      {isEdit ? (
                        <input
                          type="number"
                          className="form-control"
                          name="budget_max"
                          value={formData.budget_max || ""}
                          onChange={handleInputChange}
                          placeholder="4000000"
                        />
                      ) : (
                        <div className="form-control-plaintext">
                          {formData.budget_max || "N/A"}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Status & Assignment */}
                <div
                  style={{
                    background: "#fafafa",
                    padding: "20px",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div className="mb-3">
                    <p
                      className="mb-1"
                      style={{ fontWeight: 500, color: "#475569" }}
                    >
                      Call Response:{" "}
                      {formData?.score?.call_response_points ?? 0} / 15
                    </p>

                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-blue-600 h-2 rounded-full"
                        style={{
                          width: `${
                            ((formData?.score?.call_response_points ?? 0) /
                              15) *
                            100
                          }%`,
                        }}
                      ></div>
                    </div>
                  </div>
                  <h6
                    className="mb-3"
                    style={{
                      fontWeight: 600,
                      color: "#1e293b",
                      fontSize: "1rem",
                    }}
                  >
                    Status & Assignment
                  </h6>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="ms-1">Assigned To</label>
                      {isEdit ? (
                        <select
                          className="form-select"
                          name="assigned_user_id"
                          value={formData.assigned_user_id || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select User</option>
                          {allUsers.map((user) => (
                            <option key={user.id} value={user.id}>
                              {user.name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="form-control-plaintext">
                          {getUserName(formData.assigned_user_id)}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Initial Status</label>
                      {isEdit ? (
                        <select
                          className="form-select"
                          name="initial_status"
                          value={formData.initial_status || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Status</option>
                          {selectedOptions.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="form-control-plaintext">
                          {getStatusLabel(formData.initial_status)}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Follow-up 1</label>
                      {isEdit ? (
                        <select
                          className="form-select"
                          name="followup_1_status"
                          value={formData.followup_1_status || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Status</option>
                          {selectedOptions.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="form-control-plaintext">
                          {getStatusLabel(formData.followup_1_status)}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Follow-up 2</label>
                      {isEdit ? (
                        <select
                          className="form-select"
                          name="followup_2_status"
                          value={formData.followup_2_status || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Status</option>
                          {selectedOptions.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="form-control-plaintext">
                          {getStatusLabel(formData.followup_2_status)}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="ms-1">Final Status</label>
                      {isEdit ? (
                        <select
                          className="form-select"
                          name="final_status"
                          value={formData.final_status || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Status</option>
                          {selectedOptions.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="form-control-plaintext">
                          {getStatusLabel(formData.final_status)}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* Document Links - Dynamic Input */}
                <div
                  style={{
                    background: "#fafafa",
                    padding: "20px",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div className="mb-3">
                    <p
                      className="mb-1"
                      style={{ fontWeight: 500, color: "#475569" }}
                    >
                      Document Score: {formData?.score?.documents_points ?? 0} /
                      15
                    </p>

                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-blue-600 h-2 rounded-full"
                        style={{
                          width: `${
                            ((formData?.score?.documents_points ?? 0) / 15) *
                            100
                          }%`,
                        }}
                      ></div>
                    </div>
                  </div>
                  <h6
                    className="mb-3"
                    style={{
                      fontWeight: 600,
                      color: "#1e293b",
                      fontSize: "1rem",
                    }}
                  >
                    Document Links
                  </h6>
                  <p className="text-muted small mb-3">
                    Enter URLs for supporting documents (e.g., transcripts,
                    passports, offers).
                  </p>

                  {isEdit ? (
                    <>
                      {formData.documents.length === 0 ? (
                        <div className="text-center py-4 text-muted">
                          No documents added yet. Click "Add Document" below.
                        </div>
                      ) : (
                        <div className="mb-3">
                          {formData.documents.map((doc, index) => (
                            <div
                              key={index}
                              className="d-flex align-items-center gap-2 mb-2"
                              style={{ flexWrap: "wrap" }}
                            >
                              <label
                                className="form-label mb-0"
                                style={{ minWidth: "80px", fontWeight: "500" }}
                              >
                                Document {index + 1}
                              </label>
                              <input
                                type="url"
                                className="form-control flex-grow-1"
                                placeholder="https://example.com/document.pdf"
                                value={doc}
                                onChange={(e) =>
                                  handleDocumentChange(index, e.target.value)
                                }
                                aria-label={`Document ${index + 1} URL`}
                                style={{ flex: 1 }}
                              />
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => removeDocumentRow(index)}
                                disabled={formData.documents.length <= 1}
                                title="Remove document"
                              >
                                <FaIcons.FaTrash size={14} />
                              </button>
                            </div>
                          ))}
                        </div>
                      )}

                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={addDocumentRow}
                        style={{ marginTop: "10px" }}
                      >
                        <FaIcons.FaPlusCircle className="me-1" size={16} />
                        Add Another Document
                      </button>
                    </>
                  ) : (
                    <div
                      className="form-control-plaintext"
                      style={{ minHeight: "80px", whiteSpace: "pre-line" }}
                    >
                      {formData.documents_link &&
                      formData.documents_link
                        .split(",")
                        .filter((doc) => doc.trim() !== "").length > 0
                        ? formData.documents_link
                            .split(",")
                            .map((doc, index) => (
                              <span className="d-flex gap-1">
                                Document {index + 1}:{" "}
                                <a
                                  key={index}
                                  href={doc.trim()}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    display: "block",
                                    color: "#0d6efd",
                                    textDecoration: "underline",
                                    marginBottom: "4px",
                                  }}
                                >
                                  {doc.trim().substring(0, 50)}
                                  {doc.trim().length > 50 ? "..." : ""}
                                </a>
                              </span>
                            ))
                        : "N/A"}
                    </div>
                  )}
                </div>

                {/* Comments */}
                <div
                  style={{
                    background: "#fafafa",
                    padding: "20px",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <h6
                    className="mb-3"
                    style={{
                      fontWeight: 600,
                      color: "#1e293b",
                      fontSize: "1rem",
                    }}
                  >
                    Comments
                  </h6>
                  {isEdit ? (
                    <textarea
                      className="form-control"
                      name="details_comment"
                      value={formData.details_comment || ""}
                      onChange={handleInputChange}
                      rows="3"
                      placeholder="Add any additional notes..."
                    />
                  ) : (
                    <div
                      className="form-control-plaintext"
                      style={{ minHeight: "80px" }}
                    >
                      {formData.details_comment || "N/A"}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div
              className="modal-footer"
              style={{
                background: "#f7f8fa",
                borderTop: "1px solid #eef2f6",
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => {
                  setErrors({});
                  onClose();
                }}
              >
                Close
              </button>
              {isEdit && (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleEditSubmit}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Saving...
                    </>
                  ) : (
                    "Save Changes"
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeadsModel;
